import { render, staticRenderFns } from "./muokkaa-yek-poissaoloa.vue?vue&type=template&id=2a5508b9&scoped=true&"
import script from "./muokkaa-yek-poissaoloa.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-yek-poissaoloa.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-yek-poissaoloa.vue?vue&type=style&index=0&id=2a5508b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5508b9",
  null
  
)

export default component.exports